// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-blue-haven -> gallery-residential-blue-haven -> neuhaus-woodlands
// Generated: 2026-11-05T18:34:41.223Z
// Counts: 1 design, 46 content, 0 slot group, 3 collection binding, 6 section, 0 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_color_3"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "discoveramenities.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Get to Know <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for <br>Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "tabbedcallouts.section_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><strong>Find Your Space</strong></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourintro.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_virtualtours_blurb"
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility Statement</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesfeatures.apartmentBannerHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesfeatures.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>No detail overlooked</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesfeatures.communityBannerHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesfeatures.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>All the amenities you will ever need.</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Luxury Apartment Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "applynowoptions.intro": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_applynow_blurb"
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reach out to us</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "discoveramenities.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover All The Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplansintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Experience <span data-type=\"field-token\" data-field=\"property_name\"></span> Living</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-intro.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the <span data-type=\"field-token\" data-field=\"property_name\"></span> Neighborhood</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-intro.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pets_blurb"
  },
  "pet-policy-intro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-Friendly Living at <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find Your Island Escape</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.intro": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_residentaccess_blurb"
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-intro.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_scheduletour_blurb"
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.intro": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_thankyou_blurb"
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Tour <span data-type=\"field-token\" data-field=\"property_name\"></span> From Anywhere</h2>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {};

export const collectionBindingOverrides = {
  "amenitiesfeatures.apartmentPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_f1593d3f-201d-4205-811f-b4aa679cbe79",
      "custom_7f82a6ff-56f5-44ae-b9dc-6ec765957e41",
      "custom_a7370414-4b5b-44cc-95ed-d6b82a83e54c",
      "custom_998141be-1729-43ba-9473-4ff783804d6d",
      "custom_0dc97c51-cd53-414a-95b3-5f9f9c6937bd",
      "custom_b7f4be5d-2af0-476e-ac2d-e689ae63ceb1",
      "custom_7fb1e5d3-614c-4564-aada-1cc1fed128d7",
      "custom_3ce6f320-290d-4a17-a783-313815e4751f",
      "custom_fa7414c1-ea66-4513-a245-684d2cefc1c6",
      "custom_a623c4dc-afe2-400d-9c10-926c3294e813",
      "custom_8a86b357-af67-4a14-9440-f1e7486d865d",
      "custom_7bd13f01-dec9-4e22-9b11-bd823d389e20",
      "custom_49d0fb28-7051-42ec-9039-0bb7aa5001b7",
      "custom_23ed4e07-4bda-4126-ac19-587ae83278ae"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitiesfeatures.communityPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_57a1dc9e-f810-479b-bbaf-695e20148c7e",
      "custom_e64863e3-8a8d-4ccb-a97d-7a919123917e",
      "custom_aca56545-d823-4a05-8299-a7b6939e3961",
      "custom_e73a58f3-7a0f-4192-8434-2d0e65098bd3",
      "custom_22906ee6-1654-4b17-86ce-37aa419629cf",
      "custom_225332f9-5d08-4fba-9bb9-3cdddd530835",
      "custom_36cd7355-b165-435c-ad6b-8207e5ed8278",
      "custom_4153518d-379b-4559-849b-f5360c368692",
      "custom_702001af-27e5-4426-93f3-5070394d2820",
      "custom_5cc675dc-ece2-408d-9cdc-0237da57c970",
      "custom_b2f254bb-cbea-4b79-8736-98e8d3428733",
      "custom_9a018e75-4521-4294-92c6-7e1578bca10f",
      "custom_2360ade8-9286-4ae6-8c3a-4fb114ef151a",
      "custom_9150f45d-afd9-48c5-954c-2cbe5bd8b3c4",
      "custom_370da9d4-f775-42dd-a6ce-43391df919f4",
      "custom_ab47d885-8c28-4647-985d-581ddb90cdf9",
      "custom_8c822211-15a9-437a-85e0-81d631825e49",
      "custom_ce0287a3-f133-40bb-b1ab-956a87ab8d7a",
      "custom_69416bef-8144-438f-a270-533be033a4ea",
      "custom_ce302b94-9166-4321-a457-b6c3d50ec60f",
      "custom_baaf44d7-80c7-4bbf-8f34-570957285bdb",
      "custom_e3015ff9-734c-4f94-a387-7799c8c81942",
      "custom_efb4d7bb-ca00-4363-af35-87993ddd4f35",
      "custom_1ea1d2de-9530-49f0-9350-e20afadf98b1",
      "custom_0d693e5b-d810-4699-90b2-985a45b4911c",
      "custom_13ed9ce0-7116-48fc-979d-28e68ddba4d4",
      "custom_59a70048-462d-4f2e-8835-4f7764e96e6d",
      "custom_558f9424-901f-401d-9b08-35b2671f9ee3"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "discoveramenities.items": {
    "limit": 6,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 7
    }
  ]
};

export const styleOverrides = {};
